import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import ContentSection from "../components/home/ContentSection";
import Footer from "../components/home/Footer";
import HeroSection from "../components/home/HeroSection";
import NavBar from "../components/home/Navbar";
import QuickInquiryModal from "../components/home/QuickInquiryModal";
import {
  benefits,
  ctaData,
  features,
  footerSections,
  heroData,
  roles,
} from "../components/home/homeData";

export default function Home() {

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    html.style.overflow = "auto";
    body.style.overflow = "auto";

    html.style.overscrollBehavior = "auto";
    body.style.overscrollBehavior = "auto";

    return () => {
      html.style.overflow = "";
      body.style.overflow = "";

      html.style.overscrollBehavior = "";
      body.style.overscrollBehavior = "";
    };
  }, []);

  const { hash } = useLocation();
  const [isQuickInquiryOpen, setIsQuickInquiryOpen] = useState(false);
  const [quickInquiryPosition, setQuickInquiryPosition] = useState<{ top: number; left: number } | null>(null);

  useEffect(() => {
    if (!hash) {
      return;
    }

    const sectionId = decodeURIComponent(hash.replace("#", ""));
    const scrollToSection = () => {
      const section = document.getElementById(sectionId);
      if (section) {
        section.scrollIntoView();
        return true;
      }
      return false;
    };

    if (scrollToSection()) {
      return;
    }

    const timer = window.setTimeout(() => {
      scrollToSection();
    }, 50);

    return () => {
      window.clearTimeout(timer);
    };
  }, [hash]);

  const openQuickInquiry = (
    event: React.MouseEvent<HTMLButtonElement>,
    source: "content" | "footer"
  ) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const panelWidth = 360;
    const panelHeight = 430;
    const viewportPadding = 12;

    let left = rect.right + 10;
    if (left + panelWidth > window.innerWidth - viewportPadding) {
      left = rect.left - panelWidth - 10;
    }
    left = Math.max(viewportPadding, Math.min(left, window.innerWidth - panelWidth - viewportPadding));

    let top = rect.bottom + 10;
    if (source === "footer") {
      top = rect.top - panelHeight - 10;
    }
    top = Math.max(viewportPadding, Math.min(top, window.innerHeight - panelHeight - viewportPadding));

    setQuickInquiryPosition({ top, left });
    setIsQuickInquiryOpen(true);
  };

  return (
    <div className="min-h-screen bg-white pt-10 font-sans">
      <NavBar signInHref="/login" signUpHref="/registration" />
      <HeroSection hero={heroData} />
      <ContentSection
        features={features}
        roles={roles}
        benefits={benefits}
        ctaData={ctaData}
        onQuickInquiryClick={(event) => openQuickInquiry(event, "content")}
      />
      <Footer sections={footerSections} onQuickInquiryClick={(event) => openQuickInquiry(event, "footer")} />
      <QuickInquiryModal
        isOpen={isQuickInquiryOpen}
        position={quickInquiryPosition}
        onClose={() => setIsQuickInquiryOpen(false)}
      />
    </div>
  );
}